/**
 * RISK-IMPORT.MODAL
 * Proceed to import data
 */
import riskStore from "../../model/risk.store"
import { useAppSelector } from "@/core/root-reducer"
import CardContainer from "@/components/card-container"
import CardButton from "@/components/card-button"
import { faPlusCircle, faSyncAlt } from "@fortawesome/free-solid-svg-icons"
import Modal from "@/components/modal"
import { useState } from "react"
import LoadingModal from "@/modals/loading.modal"
import { RiskMapping } from "../../model/risk.types"

type Props = {
  attributes: string[]
  onClose: Function
  onImport: (replace: boolean) => void
  mapping: RiskMapping
}

const CARDS = [
  {
    id: "add",
    icon: faPlusCircle,
    title: "Ajouter aux risques actuels",
    text: "Les risques existants dans IDTree ne seront pas supprimées."
  },
  {
    id: "replace",
    icon: faSyncAlt,
    title: "Remplacer le document existant.",
    text: "Les risques existants seront supprimés ou archivés."
  }
]

export default function RiskImportModal(props: Props) {
  const _session = useAppSelector((state) => state._session)
  const status = useAppSelector(riskStore.selectors.status)

  const [selectedCard, setSelectedCard] = useState(CARDS[0].id)

  return (
    <Modal
      onClose={() => props.onClose()}
      onNext={() => props.onImport(selectedCard === "replace")}
      isCloseButtonVisible
      disableKeyEvents
      title="Importer le document">
      {status === "STATUS_SAVING" && <LoadingModal />}

      <CardContainer>
        {CARDS.map((card) => (
          <div key={card.id}>
            <CardButton
              icon={card.icon}
              iconColor={_session.accountColors.brandPrimary}
              title={card.title}
              isCta={selectedCard === card.id}
              onClick={() => setSelectedCard(card.id)}
            />
            <div className="flex">
              {selectedCard === card.id && (
                <div className="grey-t flex-auto" style={{ width: 180, height: 74, textAlign: "center", fontSize: 12 }}>
                  {card.text}
                </div>
              )}
            </div>
          </div>
        ))}
      </CardContainer>
    </Modal>
  )
}
